import React, { forwardRef } from 'react';

import { useIntl } from 'react-intl';

import StatusVerifiedIcon from '@atlaskit/icon/core/status-verified';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip/Tooltip';

import { i18n } from './messages';

const TooltipTagStyles = xcss({
	display: 'flex',
});

// A custom tag element to prevent a bug where an additional 1-pixel whitespace is rendered after the target element
export const TooltipTag: React.ForwardRefExoticComponent<React.RefAttributes<HTMLElement>> =
	forwardRef<HTMLElement>((props, ref) => (
		<Box as="div" xcss={TooltipTagStyles} ref={ref as React.Ref<HTMLDivElement>} {...props} />
	));

export const Verified: () => React.JSX.Element = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Tooltip content={formatMessage(i18n.verifiedIconTooltipMessage)} tag={TooltipTag}>
			<StatusVerifiedIcon
				label={formatMessage(i18n.verifiedIconLabel)}
				color={token('color.icon.accent.blue')}
			/>
		</Tooltip>
	);
};
